/*---------- Inicio Code Immer ----------*/

import '../assets/css/Counter.css'

function Counter ({numClics}) {

    return (
        <div className='counter'>
          {numClics}
        </div>
    );

}

export default Counter;

/*---------- Fin Code Immer ----------*/